// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"4331a70e","837":"4331a70e"}[chunkId] + ".chunk.css";
};